import { HttpClient } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { Observable, of } from 'rxjs';
import {environment} from '../../../environments/environment'
import { CallsInMemoryService } from 'src/app/shared/in-memory-web-api/calls-in-memory.service';
import { SiteStettingService } from './site-stetting.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  public appConfig: any;
  public service: any;


  constructor(private http: HttpClient , private _siteStettigService: SiteStettingService , private _callsInMemoryService: CallsInMemoryService) { }

  loadAppConfig() {
    //change for inMemory Mode
    if(environment.inMemoryWebApi){
      this.service = this._callsInMemoryService;
      //alert("is dev mode - inMemory")
      return this.http.get('api/SelfServices/assets/data/config.json')
       .toPromise()
       .then(data => {
         this.appConfig = data;
       });
    }
    else{
      this.service = this._siteStettigService;    
        //alert("not dev mode - siteService")
      return this.http.get('./assets/data/config.json')

       .toPromise()
       .then(data => {
         this.appConfig = data;
       });
   }

  }

  get baseUrl2ApiCalls() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.baseUrl2ApiCalls;
  }
  get CommonQuestions() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ReCaptcha.SiteKey;
  }
  
  get siteKey() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.CommonQuestions;
  }

  getCommonQuestions():Observable<any>{
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return of(this.appConfig.CommonQuestions);
  }


  getTimeUserLocked():Observable<any>{
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return of(this.appConfig.timeUserLocked);
  }
  
  getPhonePrefix():Observable<any>{
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return of(this.appConfig.phonePrefix);
  }

  getLinks():Observable<any>{
    console.log("call getLinks")

    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }  
    return of(this.appConfig.Links);
  }

getLogoutTime():Observable<any>{
  console.log("call app.getLogoutTime")
  if (!this.appConfig) {
    throw Error('Config file not loaded!');
  }
  return of(this.appConfig.logoutTime);
  
}
getPhoneSupport():Observable<any>{
  if (!this.appConfig) {
    throw Error('Config file not loaded!');
  }
  return of(this.appConfig.phoneSupport);
  
}

getPhoneSupportMoe():Observable<any>{
  if (!this.appConfig) {
    throw Error('Config file not loaded!');
  }
  return of(this.appConfig.phoneSupportMoe);
  
}
  
  getSupportBrowsers():Observable<any>{
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return of(this.appConfig.supportedBrowsers);
  }
}